import React, { useState, useEffect, useRef, useCallback, Fragment } from 'react';
import { DataGridPro, GridToolbarContainer, GridToolbarExport, GridToolbarQuickFilter, GridColumnMenu, gridFilterableColumnLookupSelector, useGridApiRef, gridFilteredSortedRowIdsSelector, GRID_CHECKBOX_SELECTION_COL_DEF, GridFooter, GridFilterInputValue, getGridStringOperators } from '@mui/x-data-grid-pro';
import { connect } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Modal from '@mui/material/Modal';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Dropdown from 'react-bootstrap/Dropdown';
import { VscFolderActive } from 'react-icons/vsc';
import { ToastContainer } from 'react-toastify';
import { formatShorthand, formatPhone } from '../../common/utils';
import BorrowerNamesInGrid from '../../containers/Loans/BorrowerNamesInGrid';
import { FaChevronDown } from 'react-icons/fa';
import { ClosedLoansModal } from '../../contexts';
import AddToGroup from '../../components/Modals/AddToGroup';
import AddEvent from '../../components/Modals/AddEvent';
import SendMassTxt from '../../components/Modals/SendMassTxt';
import SendMassEmail from '../../components/Modals/SendMassEmail';
import LaunchPhoneBurner from '../../components/Modals/LaunchPhoneBurner';
import { singleSelectQuickFilter } from '../../common/utils';
import { update } from '../../common/api';
import Toolbar from './toolbar';


import "react-toastify/dist/ReactToastify.css";
import '../../containers/Dashboard/dashboard.css';

function useQuery() {
    return new URLSearchParams( useLocation().search );
}

const customColumnMenu = ( props ) => {
    return (
        <GridColumnMenu
            { ...props }
            slots={ {
                columnMenuColumnsItem: null,
                columnMenuPinningItem: null
            } }
        />
    );
}

const customFilterDoesNotContain = {
    label: 'doesn\'t contain',
    value: 'doesNotContain',
    getApplyFilterFn: ( filterItem ) => {
        if ( !filterItem.field || !filterItem.value || !filterItem.operator ) {
            return null;
        }
        return ( { value } ) => {
            return !value || typeof( value ) !== 'string' || !value.toLowerCase().includes( filterItem.value.toLowerCase() );
        }
    },
    InputComponent: GridFilterInputValue,
};

const LoansClosed = ( { orgId, aid, uid, user, stack, grids, viewing, canExport, loans, contacts, status, setDatagridWidth, setDatagridOrder } ) => {
    const [ trx, setTrx ] = useState( 0 );
    const [ vol, setVol ] = useState( 0 );
    const [ rev, setRev ] = useState( 0 );
    const [ loading, setLoading ] = useState( true );
    const [ closed, setClosed ] = useState( [] );
    const [ selectedRows, setSelectedRows ] = useState( [] );
    const [ gridHeight, setGridHeight ] = useState( 0 );
    const [ containerBuffer, setContainerBuffer ] = useState( 125 );
    const [ cols, setCols ] = useState( [] );
    const [ gridReady, setGridReady ] = useState( false );
    const [ hasPhoneBurner, setHasPhoneBurner ] = useState( false );
    const [ hasTxting, setHasTxting ] = useState( false );
    const [ filterModel, setFilterModel ] = useState( { items: [] } );
    const [ q, setQ ] = useState( '' );
    const [ classLogic, setClassLogic ] = useState( '' );
    const [ rowModesModel, setRowModesModel ] = useState( {} );
    const [ usingFilter, setUsingFilter ] = useState( false );
    const [ filterName, setFilterName ] = useState( '' );

    const [show, setShow] = useState(false);
    const closeModal = () => setShow(false);
    const openModal = () => setShow(true);
    const [ modal, setModal ] = useState();

    const gridRef = useGridApiRef();
    const containerRef = useRef();
    const titleRef = useRef();
    const numbersRef = useRef();

    const location = useLocation();

    const query = useQuery();

    const handleColumnWidthChange = async ( { colDef, width } ) => {
        const datagrid = 'closedloans';

        let newWidths = {};
        gridRef.current.getAllColumns().forEach( col => {
            if ( ![ '__check__', 'actions' ].includes( col.field ) ) {
                newWidths[col.field] = col.width;
            }
        } );
        setDatagridWidth( { grid: datagrid, values: newWidths, fn: filterName } );
        await update( orgId, aid, uid, 'datagrid-width', uid, {
            grid: datagrid,
            values: newWidths,
            fn: filterName
        } );
    }

    const handleColumnOrderChange = async ( params ) => {
        const datagrid = 'closedloans';

        const newOrder = [];
        gridRef.current.getAllColumns().forEach( col => {
            if ( ![ '__check__', 'actions' ].includes( col.field ) ) {
                newOrder.push( col.field );
            }
        } );
        setDatagridOrder( { grid: datagrid, values: newOrder, fn: filterName } );
        await update( orgId, aid, uid, 'datagrid-order', uid, {
            grid: datagrid,
            values: newOrder,
            fn: filterName
        } );
    }

    const formatName = ( cid ) => {
        const c = contacts[cid]; // .find( con => con.cid === cid );
        if ( !c ) {
            return null;
        }
        let n = c.firstname;
        if ( c.namePreferred && c.namePreferred.length ) {
            n = c.namePreferred;
        }
        if ( c.lastname && c.lastname.length ) {
            n += ' ' + c.lastname;
        }
        
        return n.trim();
    };

    const gridHelpers = {
        valueGetter: {
            borrowers: ( params ) => {
                let v = [];
                if ( params.row.borrowers ) {
                    params.row.borrowers.forEach( b => {
                        const c = contacts[b.cid];
                        if ( c ) {
                            v.push( formatName( c.cid ) );
                        }
                    } );
                }
                return v.join( ', ' );
            },
            phoneBorr: ( { row } ) => {
                let p;  
                if ( row.borrowers && row.borrowers.length ) {
                    const pri = row.borrowers.find( f => f.label === 'Primary' ) || row.borrowers[0];
                    if ( pri ) {
                        const c = contacts[pri.cid];
                        if ( c && c.phoneMobile && c.phoneMobile.length ) {
                            p = c.phoneMobile;
                        } else if ( c && c.phone && c.phone.length ) {
                            p = c.phone;
                        }
                    }
                }
                return ( p ) ? formatPhone( p ) : null;
            },
            phoneBA: ( { row } ) => {
                let p;  
                if ( row.baId ) {
                    const c = contacts[row.baId];
                    if ( c && c.phoneMobile && c.phoneMobile.length ) {
                        p = c.phoneMobile;
                    } else if ( c && c.phone && c.phone.length ) {
                        p = c.phone;
                    }
                }
                return ( p ) ? formatPhone( p ) : null;
            },
            phoneLA: ( { row } ) => {
                let p;  
                if ( row.laId ) {
                    const c = contacts[row.laId];
                    if ( c && c.phoneMobile && c.phoneMobile.length ) {
                        p = c.phoneMobile;
                    } else if ( c && c.phone && c.phone.length ) {
                        p = c.phone;
                    }
                }
                return ( p ) ? formatPhone( p ) : null;
            },
            emailBorr: ( { row } ) => {
                let e;
                if ( row.borrowers && row.borrowers.length ) {
                    const pri = row.borrowers.find( f => f.label === 'Primary' ) || row.borrowers[0];
                    if ( pri ) {
                        const c = contacts[pri.cid];
                        if ( c && c.email && c.email.length ) {
                            e = c.email;
                        }
                    }
                }
                return ( e ) ? e : null;
            },
            nameBA: ( { row } ) => {
                let n;
                if ( row.baId ) {
                    n = formatName( row.baId );
                }
                return ( n ) ? n : null;
            },
            nameLA: ( { row } ) => {
                let n;
                if ( row.laId ) {
                    n = formatName( row.laId );
                }
                return ( n ) ? n : null;
            },
            emailBA: ( { row } ) => {
                let e;
                if ( row.baId ) {
                    const c = contacts[row.baId];
                    if ( c && c.email && c.email.length ) {
                        e = c.email;
                    }
                }
                return ( e ) ? e : null;
            },
            emailLA: ( { row } ) => {
                let e;
                if ( row.baId ) {
                    const c = contacts[row.baId];
                    if ( c && c.email && c.email.length ) {
                        e = c.email;
                    }
                }
                return ( e ) ? e : null;
            },
            ooeBorr: ( { row } ) => {
                let oo = false;
                if ( row.borrowers && row.borrowers.length ) {
                    const pri = row.borrowers.find( f => f.label === 'Primary' ) || row.borrowers[0];
                    if ( pri ) {
                        const c = contacts[pri.cid];
                        if ( c && c.optoutEmail ) {
                            oo = c.optoutEmail;
                        }
                    }
                }
                return ( oo );
            },
            oocBorr: ( { row } ) => {
                let oo = false;
                if ( row.borrowers && row.borrowers.length ) {
                    const pri = row.borrowers.find( f => f.label === 'Primary' ) || row.borrowers[0];
                    if ( pri ) {
                        const c = contacts[pri.cid];
                        if ( c && c.optoutCall ) {
                            oo = c.optoutCall;
                        }
                    }
                }
                return ( oo );
            },
            oosBorr: ( { row } ) => {
                let oo = false;
                if ( row.borrowers && row.borrowers.length ) {
                    const pri = row.borrowers.find( f => f.label === 'Primary' ) || row.borrowers[0];
                    if ( pri ) {
                        const c = contacts[pri.cid];
                        if ( c && c.optoutSms ) {
                            oo = c.optoutSms;
                        }
                    }
                }
                return ( oo );
            },
            date: ( { value } ) => {
                let d;
                if ( value ) {
                    d = new Date( ( value.match( 'T' ) ) ? value : value + 'T12:00:00' );
                    // d.setDate( d.getDate() + 1 );
                }
                return ( d ) ? d : null;
            },
            referral: ( { row } ) => {
                let n;
                const l = loans[row.id];
                if ( l && l.borrowers && l.borrowers.length ) {
                    const pri = row.borrowers.find( f => f.label === 'Primary' ) || row.borrowers[0];
                    if ( pri ) {
                        const c = contacts[pri.cid];
                        if ( c && c.referredById ) {
                            n = formatName( c.referredById );
                        }
                    }
                }
                return n;
            },
            rank: ( params ) => {
                let rank;
                if ( params.row.borrowers ) {
                    const pri = params.row.borrowers.find( f => f.label === 'Primary' );
                    if ( pri ) {
                        const c = contacts[pri.cid];
                        if ( c && c.rank ) {
                            rank = c.rank;
                        }
                    }
                }
                return rank;
            },
            rate: ( { value } ) => {
                let d;
                if ( value ) {
                    // Remove any non-numeric characters except for the decimal point and percent sign
                    let cleanedValue = value.toString().replace(/[^0-9.%]+/g, '');

                    // Check if the value contains a percent sign
                    if ( cleanedValue.includes( '%' ) ) {
                        // Remove the percent sign and convert to float, then divide by 100
                        d = parseFloat( cleanedValue.replace( '%', '') );
                    } else {
                        // Convert the cleaned value to float
                        d = parseFloat( cleanedValue );
                    }
                }
                return d;
            }
        },
        renderCell: {
            loanname: ( params ) => <Link to={`/loan/${params.row.id}`}>{params.value}</Link>,
            borrowers: ( { row } ) => <BorrowerNamesInGrid row={row} />,
            phone: ( { value } ) => {
                return ( value ) ? <a href={`tel:${value}`}>{value}</a> : null;
            },
            email: ( { value } ) => {
                return ( value ) ? <a href={`mailto:${value}`}>{value}</a> : null;
            },
            date: ( { value } ) => {
                let d;
                if ( value ) {
                    d = value.toLocaleDateString();
                }
                return d;
            },
            contact: ( { value } ) => {
                let l;
                if ( value ) {
                    const c = contacts[value];
                    if ( c ) {
                        l = <Link to={`/contact/${c.cid}`}>{ formatName( c.cid ) }</Link>
                    }
                }
                return l;
            },
            referral: ( { row } ) => {
                let r;
                const l = loans[row.id];
                if ( l && l.borrowers && l.borrowers.length ) {
                    const c = contacts[l.borrowers[0].cid];
                    if ( c && c.referredById ) {
                        r = <Link to={`/contact/${c.referredById}`}>{ formatName( c.referredById ) }</Link>
                    }
                }
                return r;
            },
            fileNum: ( { row } ) => {
                return ( row.lid && row.fileNum ) ? <Link to={`/loan/${row.lid}`}>{row.fileNum}</Link> : null;
            }
        },
        valueFormatter: {
            phone: ( { value } ) => {
                return ( value ) ? value : null;
            },
            email: ( { value } ) => {
                return ( value ) ? value : null;
            },
            date: ( { value } ) => {
                return ( value ) ? value.toLocaleDateString() : null;
            },
            contact: ( { value } ) => {
                let n;
                if ( value ) {
                    const c = contacts[value];
                    if ( c ) {
                        n = formatName( c.cid );
                    }
                }
                return n;
            },
            referral: ( { value } ) => {
                return ( value ) ? value : '';
            }
        },
        getApplyQuickFilterFn: {
            singleSelectQuickFilter: singleSelectQuickFilter
        }
    };
    
    const updateKPIs = useCallback( ( model, details ) => {
        const stages = new Set();
        closed.forEach( a => {
            if ( a.stage && a.stage.length ) {
                stages.add( a.stage );
            }
        } );
        // console.log( stages );
        // setStages( [...stages] );

        const c = gridFilterableColumnLookupSelector( gridRef );
        if ( c.stage ) {
            c.stage.valueOptions = [ ...Array.from( stages ) ];
        }
        
        const visibleRows = gridFilteredSortedRowIdsSelector( gridRef );
        const rows = closed.filter( d => visibleRows.includes( d.id ) );
        setTrx( rows.length );

        let v = 0;
        let rev = 0;
        rows.forEach( r => {
            if ( r.amount ) {
                let amt = r.amount;
                if ( typeof( amt ) === 'string' ) {
                    amt = amt.replace( '$', '' );
                    amt = amt.replace( /,/g, '' );
                    amt = amt.replace( /\.\d\d/, '' );
                    amt = Number( amt );
                }
                v += amt;
            }
            if ( r.revenue ) {
                let amt = r.revenue;
                if ( typeof( amt ) === 'string' ) {
                    amt = amt.replace( '$', '' );
                    amt = amt.replace( /,/g, '' );
                    amt = amt.replace( /\.\d\d/, '' );
                    amt = Number( amt );
                }
                rev += amt;
            }
        } );
        setVol( v );
        setRev( rev );
    }, [ closed, gridRef ] );

    const handleModal = ( t ) => {
        let shouldOpen = true;

        const allLids = [];
        const emailLids = [];
        const phoneLids = [];
        const uniqueEmails = new Set();
        const uniquePhones = new Set();
        selectedRows.forEach( lid => {
            const l = loans[lid];
            if ( l.borrowers?.length ) {
                let seenEmails = false;
                let seenPhones = false;
                
                allLids.push( lid );
                                
                for ( const b of l.borrowers ) {
                    const c = contacts[b.cid];
                    if ( c ) {
                        if ( c?.email && ( uniqueEmails.has( c.email.toLowerCase() ) || c.optoutEmail ) ) {
                            seenEmails = true;
                        }
                        let p = c.phoneMobile || c.phone || c.phoneWork || c.phoneHome;
                        if ( p && ( uniquePhones.has( formatPhone( p  ) ) || c.optoutSms ) ) {
                            seenPhones = true;
                        }
                    }
                }
                
                if ( !seenEmails ) {
                    emailLids.push( lid );
                }
                if ( !seenPhones ) {
                    phoneLids.push( lid );
                }
            }
        } );
                
        switch ( t ) {
            case 'email-mass':
                setModal( <SendMassEmail close={closeModal} llist={emailLids} objType='loan' aid={viewing[0]} /> );
                break;

            case 'sms-mass':
                setModal( <SendMassTxt close={closeModal} llist={phoneLids} objType='loan' /> );
                break;
    
            case 'list':
                setModal( <AddToGroup close={closeModal} itemType='loans' items={allLids} aid={viewing[0]} /> );
                break;
    
            case 'event':
                // setModal( <AddEvent close={closeModal} contacts={list} /> );
                break;

            case 'phoneburner':
                setModal( <LaunchPhoneBurner close={closeModal} type='loans' data={allLids} /> );
                break;
    
            default:
                shouldOpen = false;
                console.log( 'Unknown modal type: ' + t );
        }

        if ( shouldOpen ) {
            openModal();
        }
    }

    const getRowClassName = ( params ) => {
        let cn = '';
        // console.log( classLogic );
        if ( classLogic ) {
            eval( classLogic );
        }
        return cn;
    }

    useEffect(() => {
        document.title = 'Third Floor - Closed Loans';
    }, [] );

    useEffect( () => {
        let filters = {};
        for ( let [ key, value ] of query.entries() ) {
            filters[key] = value;
        }

        if ( grids && grids.closedloans && !gridReady ) {
            let activeFilter = false;
            setFilterName( '' );

            let storedCols = JSON.parse( grids.closedloans.cols );
            if ( filters.fn && grids.closedloans.filters && grids.closedloans.filters[filters.fn] ) {
                if ( grids.closedloans.filters[filters.fn].cols ) {
                    activeFilter = true;
                    setUsingFilter( true );
                    setFilterName( filters.fn );
                    storedCols = JSON.parse( grids.closedloans.filters[filters.fn].cols );
                }

                if ( grids.closedloans.filters[filters.fn].criteria ) {
                    const crit = JSON.parse( grids.closedloans.filters[filters.fn].criteria );
                    setFilterModel( { items: crit } );
                }

                if ( grids.closedloans.filters[filters.fn].className ) {
                    setClassLogic( grids.closedloans.filters[filters.fn].className );
                }
            } else {
                // if ( filters.crit ) {
                //     const crit = JSON.parse( filters.crit );
                //     setFilterModel( { items: crit } );
                // }
                if ( grids.closedloans.filters && grids.closedloans.filters['*'] && grids.closedloans.filters['*'].criteria ) {
                    const crit = JSON.parse( grids.closedloans.filters['*'].criteria );
                    setFilterModel( { items: crit } );
                }

                if ( grids.closedloans.className ) {
                    setClassLogic( grids.closedloans.className );
                }
            }

            if ( storedCols ) {
                let cols = storedCols.map( c => {
                    if ( c.renderCell && gridHelpers.renderCell[c.renderCell] ) {
                        c.renderCell = gridHelpers.renderCell[c.renderCell];
                    }
                    if ( c.valueGetter && gridHelpers.valueGetter[c.valueGetter] ) {
                        c.valueGetter = gridHelpers.valueGetter[c.valueGetter];
                    }
                    if ( c.valueFormatter && gridHelpers.valueFormatter[c.valueFormatter] ) {
                        c.valueFormatter = gridHelpers.valueFormatter[c.valueFormatter];
                    }
                    if ( c.getApplyQuickFilterFn && gridHelpers.getApplyQuickFilterFn[c.getApplyQuickFilterFn] ) {
                        c.getApplyQuickFilterFn = gridHelpers.getApplyQuickFilterFn[c.getApplyQuickFilterFn];
                    }
                    
                    if ( user && user.datagrids && user.datagrids.closedloans ) {
                        if ( activeFilter ) {
                            if ( user.datagrids.closedloans.filters && user.datagrids.closedloans.filters[filters.fn] && user.datagrids.closedloans.filters[filters.fn].colSize && user.datagrids.closedloans.filters[filters.fn].colSize[c.field] ) {
                                c.width = user.datagrids.closedloans.filters[filters.fn].colSize[c.field];
                            }
                        } else if ( user.datagrids.closedloans.colSize && user.datagrids.closedloans.colSize[c.field] ) {
                            c.width = user.datagrids.closedloans.colSize[c.field];
                        }
                    }
                    // c.editable = true;
                    if ( !c.type || c.type === 'string' ) {
                        c.filterOperators = [
                            ...getGridStringOperators(), // Get existing operators
                            customFilterDoesNotContain, // Add custom operator
                        ];
                    }

                    return c;
                } );

                if ( user && user.datagrids && user.datagrids.closedloans ) {
                    if ( activeFilter ) {
                        if ( user.datagrids.closedloans.filters && user.datagrids.closedloans.filters[filters.fn] && user.datagrids.closedloans.filters[filters.fn].colOrder && user.datagrids.closedloans.filters[filters.fn].colOrder.length ) {
                            cols = user.datagrids.closedloans.filters[filters.fn].colOrder.map( field => {
                                return storedCols.find( f => f.field === field );
                            } );
                        }
                    } else {
                        if ( user.datagrids.closedloans.colOrder && user.datagrids.closedloans.colOrder.length ) {
                            cols = user.datagrids.closedloans.colOrder.map( field => {
                                return storedCols.find( f => f.field === field );
                            } );
                        }
                    }
                }

                setCols( cols );
                setGridReady( true );
            }
        }
    }, [ user, query, grids, gridHelpers.renderCell, gridHelpers.valueGetter, gridHelpers.valueFormatter, gridHelpers.getApplyQuickFilterFn, gridReady, gridRef ] );
    
    useEffect( () => {
        if ( user.additionalAccounts && user.additionalAccounts.length > 1 ) {
            setContainerBuffer( prev => prev + 30 );
        }
    }, [ user.additionalAccounts ] );

    useEffect( () => {
        setGridHeight( containerRef.current.clientHeight - titleRef.current.clientHeight - numbersRef.current.clientHeight - 15 );
    }, [ containerBuffer ] );

    useEffect( () => {
        if ( loans ) {
            const stats = status.filter( s => s.queue === 'won' ).map( m => m.value );
            let list = [];
            Object.keys( loans ).forEach( lid => {
                const l = loans[lid];

                if ( stats.includes( l.status ) && viewing.includes( l.aid ) ) {
                    let c;
                    if ( l.borrowers && l.borrowers.length ) {
                        l.borrowers.sort( ( a, b ) => {
                            if ( a.label === 'Primary' ) {
                                return -1;
                            }
                            if ( b.label === 'Primary' ) {
                                return 1;
                            }
                            return 0;
                        } );
                        c = contacts[l.borrowers[0].cid];
                    }
                    
                    list.push( {
                        ...c,
                        ...l,
                        referredById: ( c ) ? c.referredById : null,
                        rank: ( c ) ? c.rank : null,
                    } );
                }
            } );
            list.sort( ( a, b ) => {
                let ad;
                let bd;

                if ( a.fundedDate ) {
                    ad = new Date( a.fundedDate );
                } else if ( a.coeDate ) {
                    ad = new Date( a.coeDate );
                }
                if ( b.fundedDate ) {
                    bd = new Date( b.fundedDate );
                } else if ( b.coeDate ) {
                    bd = new Date( b.coeDate );
                }

                if ( !ad && !bd ) {
                    return 0;
                }
                if ( !ad ) {
                    return 1;
                }
                if ( !bd ) {
                    return -1;
                }
                return bd.getTime() - ad.getTime();
            } );
            setClosed( list );
            setLoading( false );
        }
    }, [ loans, status, contacts, viewing ] );

    useEffect(() => {
        if ( location.search !== q ) {
            setGridReady( false );
            setFilterModel( { items: [] } );
            setClassLogic( '' );
            setQ( location.search );
        }
    }, [ location.search, q ] ); 

    useEffect( () => {
        if ( stack ) {
            if ( stack.dialer && stack.dialer.type === 'PhoneBurner' ) {
                setHasPhoneBurner( true );
            }
            if ( stack.sms && stack.sms ) {
                setHasTxting( true );
            }
        }
    }, [ stack ] );

    return (
        <Container fluid className='px-0' style={ { height: '100%' } }>
            <Row className='tf-page-container' style={ { height: `calc(100vh - ${containerBuffer}px)` } } ref={containerRef}>
                <Col className='p-0' style={ { height: '100%' } }>
                    <Card style={ { height: '100%' } }>
                        <Card.Body className='py-0'>
                            <Card.Title className='pt-1' ref={titleRef}>
                                <Row>
                                    <Col>
                                        <VscFolderActive />
                                        <span className='ps-2 fw-bold fs-6'>Closed Loans</span>
                                    </Col>
                                </Row>
                            </Card.Title>
                            <Card.Subtitle className='py-3' ref={numbersRef}>
                              <Row className='text-center'>
                                <Col>
                                    <Row>
                                        <Col className='tf-dashboard-section-highlight-value'>{trx}</Col>
                                    </Row>
                                    <Row>
                                        <Col className='tf-dashboard-section-highlight-label'>Loans</Col>
                                    </Row>
                                </Col>
                                <Col>
                                    <Row>
                                        <Col className='tf-dashboard-section-highlight-value'>${formatShorthand( vol, 2 )}</Col>
                                    </Row>
                                    <Row>
                                        <Col className='tf-dashboard-section-highlight-label'>Volume</Col>
                                    </Row>
                                </Col>
                                <Col>
                                    <Row>
                                        <Col className='tf-dashboard-section-highlight-value'>${formatShorthand( rev, 2 )}</Col>
                                    </Row>
                                    <Row>
                                        <Col className='tf-dashboard-section-highlight-label'>Revenue</Col>
                                    </Row>
                                </Col>
                              </Row>
                            </Card.Subtitle>
                            <Row>
                                <Col style={ { display: 'flex', height: `${gridHeight}px`, width: '100%' } }>
                                    <ClosedLoansModal.Provider value={ { openModal, closeModal, setModal } }>
                                    {
                                        ( gridReady ) ? (
                                            <DataGridPro
                                                apiRef={gridRef}
                                                initialState={ { 
                                                    pinnedColumns: { left: [ GRID_CHECKBOX_SELECTION_COL_DEF.field, 'name' ] }
                                                } }
                                                loading={ loading }
                                                rows={closed}
                                                columns={cols}
                                                density='compact'
                                                checkboxSelection
                                                disableSelectionOnClick
                                                slots={ { 
                                                    toolbar: Toolbar,
                                                    columnMenu: customColumnMenu 
                                                } }
                                                slotProps={ { toolbar: {
                                                    selectedRows: selectedRows, 
                                                    handleModal: handleModal, 
                                                    hasTxting: hasTxting, 
                                                    hasPhoneBurner: hasPhoneBurner, 
                                                    canExport: canExport,
                                                    viewing: viewing
                                                } } }
                                                onRowSelectionModelChange={ ( ids ) => setSelectedRows( ids ) }
                                                onColumnWidthChange={ handleColumnWidthChange }
                                                onColumnOrderChange={ handleColumnOrderChange }
                                                filterModel={ filterModel }
                                                onFilterModelChange={ ( newFilterModel ) => setFilterModel( newFilterModel ) }
                                                getRowClassName={ getRowClassName }
                                                editMode='row'
                                                onStateChange={updateKPIs}
                                                getRowId={ ( row ) => row.lid }
                                            />
                                        ) : (
                                            null
                                        )
                                    }
                                    </ClosedLoansModal.Provider>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <ToastContainer autoClose={3000} />
            <Modal open={show} onClose={closeModal}>
                <Fragment>{modal}</Fragment>
            </Modal>
        </Container>
    )
}

const mapProps = ( state ) => ( {
    orgId: state.user.orgId,
    aid: state.user.aid,
    uid: state.user.email,
    user: state.user,
    stack: state.user.stack,
    grids: state.user.meta.datagrids,
    viewing: state.user.viewing,
    canExport: state.user.canExport,
    loans: state.loans.byId,
    contacts: state.contacts.byId,
    status: state.user.meta.loan.picklist.status,
} );
  
const mapDispatch = ( dispatch ) => ( {
    setDatagridWidth: dispatch.user.setDatagridWidth,
    setDatagridOrder: dispatch.user.setDatagridOrder
} );
  
export default connect( mapProps, mapDispatch )( LoansClosed );